module.exports = __webpack_public_path__ + "static/img/youzhandaohang.fb5514ee.png";